// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602171615/js/" + chunkId + "." + {"44":"24b6123c","225":"686941c3","481":"0e9c9026","486":"5c9cabf7","770":"2ae2c79f"}[chunkId] + ".0.022016939422928816.chunk.js";
};